import {atomFamily} from 'recoil'

export const CurrentQuantityItem = atomFamily<number, string>({
  key: 'current-quantity-item',
  default: 1,
})
